import { render, staticRenderFns } from "./UpdateLmsdriveLink.vue?vue&type=template&id=10b98a8a&"
import script from "./UpdateLmsdriveLink.vue?vue&type=script&lang=js&"
export * from "./UpdateLmsdriveLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports